// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__xvdwZ","description":"MealItem_description__bt5kK","price":"MealItem_price__MmkQ+"};